export default __webpack_public_path__ + "static/media/female-white.602402fd.svg";